module.exports = __webpack_public_path__ + "img/level-mobile.2ada2807.png";